export const defaultArrayData = {loading: true, error: null, data: []}
export const defaultObjData   = {loading: true, error: null, data: {}}